/**
 * Returns the value of a nested field on an object or undefined if not found.
 * @param {*} nestedObj
 * @param {*} keyPath
 */
 export function dig(nestedObj, keyPath) {
    return keyPath.reduce((obj, key) =>
        ((obj && obj[key] !== 'undefined') ? obj[key] : undefined), nestedObj);
  }
